/* eslint-disable react/prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import {
  TextField,
  ListItemText,
  Checkbox,
  CircularProgress,
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'

const icon = <CheckBoxOutlineBlankIcon color="primary" fontSize="small" />
const checkedIcon = <CheckBoxIcon color="primary" fontSize="small" />

const AutocompleteV2 = React.forwardRef(function AutocompleteV2(props, ref) {
  const {
    getOptionLabel,
    helperText,
    label,
    preview,
    placeholder,
    renderListItemText,
    error,
    ...rest
  } = props
  return (
    <Autocomplete
      ref={ref}
      fullWidth
      color="primary"
      ChipProps={{ color: 'primary' }}
      getOptionLabel={(option) => getOptionLabel(option)}
      renderOption={(option, state) => (
        <React.Fragment>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={state.selected}
          />
          {renderListItemText ? (
            renderListItemText(option, state)
          ) : getOptionLabel ? (
            getOptionLabel(option)
          ) : (
            <ListItemText
              primary={
                'renderListItemText or getOptionLabel function not supplied'
              }
            />
          )}
        </React.Fragment>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          // variant="outlined"
          error={error}
          label={label ? label : undefined}
          placeholder={placeholder ? placeholder : undefined}
          helperText={helperText ? helperText : undefined}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {props?.loading ? (
                  <CircularProgress color="primary" size={20} />
                ) : null}
                {preview ? null : params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      {...rest}
    />
  )
})

export default AutocompleteV2

AutocompleteV2.propTypes = {
  getOptionLabel: PropTypes.func.isRequired,
}
